/**
 * This is the main entry point for binding the AgeGO in browser.
 *
 * @param {string} _name Name used for inline initializer
 * @param {window} scope Scope of binding, usually `window`
 * @param {navigator} navigator Browser navigator object
 */
import {AgeGO} from './agego/AgeGO';
import {OverlayRenderer} from './agego/OverlayRenderer';
import {ContentBlurRenderer} from './agego/ContentBlurRenderer';
import {AccessManager} from './agego/AccessManager';

// eslint-disable-next-line no-unused-vars
const BrowserInitializer = function (_name, scope, navigator) {
    // Initializer is invoked without inline initializer defined
    if ('function' !== typeof scope[_name]) {
        scope[_name] = {e: []};
    }

    // Ensure message buffer is an array (broken initializer)
    if (!Array.isArray(scope[_name].e)) {
        scope[_name].e = [];
    }

    const accessManager = new AccessManager();
    const contentBlurRenderer = new ContentBlurRenderer(scope);
    const overlayRenderer = new OverlayRenderer(scope, contentBlurRenderer, accessManager);
    const ageGO = new AgeGO(
        scope,
        overlayRenderer,
        contentBlurRenderer,
        accessManager
    );

    // Replace inline buffer with actual listener
    const bufferedMessages = scope[_name].e || [];
    scope[_name] = ageGO.onMessage.bind(ageGO);

    // Flush pending messages
    for (const message of bufferedMessages) {
        ageGO.onMessage.apply(ageGO, message);
    }

    scope.addEventListener('beforeunload', () => ageGO.flush());
};

export {BrowserInitializer};
